const { isNumber } = require("lodash");

var milis = false;

window.formatDateForSorting = function(dateString) {

    format = window.User.dateTimeFormat;
    if (!milis) {
        return formatDateToMilis(dateString, format)/1000;
    } 
    return formatDateToMilis(dateString, format);
}

window.formatDateToMilis = function(dateString, format = 'DD.MM.YYYY HH:mm') {
    
    if (!dateString) {
        return 0;
    }
    else if(typeof dateString === 'number'){
        return dateString;
    }
    else if (dateString.indexOf('-') == 2 && format[0] == 'Y') {
        format = format.substring(2);
    }
    var i = format.length;
    
    var m = ''
    var H = ''
    var D = ''
    var M = ''
    var Y = ''
    while (i--) {
        if (i+1 == 'A') {
            i--;
            continue;
        }
        switch(format[i]) {
            case 'm':
                m = dateString[i] + m;
                break;
            case 'H':
            case 'h':
                H = dateString[i] + H;
                break;
            case 'D':
            case 'd':
                D = dateString[i] + D;
                break;
            case 'M':
                M = dateString[i] + M;
                break;
            case 'Y':
            case 'y':
                Y = dateString[i] + Y;
                break;
        }
    }

    if (Y.length == 2) {
        let currentDate = new Date();
        let y = parseInt(Y) <= currentDate.getFullYear()%100 ? 
                currentDate.getFullYear().toString()[0] +
                currentDate.getFullYear().toString()[1] : 
                (currentDate.getFullYear() - 100).toString()[0] +
                (currentDate.getFullYear() - 100).toString()[1];
        Y = y + Y;
    }
    let newDate = new Date(Y, M-1, D, H, m);
    return newDate.getTime();
}